import React from 'react';
import { ApolloProvider } from '@material-bank/apollo-client';
import { ProjectsCustomerProvider } from '@material-bank/projects-utils';
import { IntlProvider } from '@mb/lib/i18n/CoordinatedIntlProvider';
import AutocompleteResultsContainer from './containers/AutocompleteResultsContainer/AutocompleteResultsContainer';
import SearchFormContainer from './containers/SearchFormContainer/SearchFormContainer';
import { ProviderWrapper } from './ProviderWrapper';

// This component is used to display the search bar
const SearchBar: React.FC = () => {
  return (
    <IntlProvider>
      <ProviderWrapper>
        <ApolloProvider>
          <ProjectsCustomerProvider>
            <SearchFormContainer />
            <AutocompleteResultsContainer
              autocompleteContainerId="headerMainContent"
              searchContainerId="headerSearchForm"
            />
          </ProjectsCustomerProvider>
        </ApolloProvider>
      </ProviderWrapper>
    </IntlProvider>
  );
};

export default SearchBar;
